import { aboutData } from '@/mocks/about';

export default function Features() {
  const { features, stats } = aboutData;

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择蓝莓视频？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            以技术创新驱动极致观影体验，让每一位用户享受流畅高清的视觉盛宴
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-12">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mx-auto mb-4">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary-500 to-primary-700 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-white/70">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}